// curl -s http://statsapi.mlb.com/api/v1/teams\?sportIds\=1 | jq '[.teams[] | {id, fileCode, division: .division.name, name}] | sort_by(.name) | [{"fileCode":"mlb", "name":"Major League Baseball"}] + .'

export default [
    {
        id: null,
        fileCode: null,
        name: 'Please select a team',
    },
    {
        id: 109,
        fileCode: 'ari',
        division: 'National League West',
        name: 'Arizona Diamondbacks',
    },
    {
        id: 144,
        fileCode: 'atl',
        division: 'National League East',
        name: 'Atlanta Braves',
    },
    {
        id: 110,
        fileCode: 'bal',
        division: 'American League East',
        name: 'Baltimore Orioles',
    },
    {
        id: 111,
        fileCode: 'bos',
        division: 'American League East',
        name: 'Boston Red Sox',
    },
    {
        id: 112,
        fileCode: 'chc',
        division: 'National League Central',
        name: 'Chicago Cubs',
    },
    {
        id: 145,
        fileCode: 'cws',
        division: 'American League Central',
        name: 'Chicago White Sox',
    },
    {
        id: 113,
        fileCode: 'cin',
        division: 'National League Central',
        name: 'Cincinnati Reds',
    },
    {
        id: 114,
        fileCode: 'cle',
        division: 'American League Central',
        name: 'Cleveland Guardians',
    },
    {
        id: 115,
        fileCode: 'col',
        division: 'National League West',
        name: 'Colorado Rockies',
    },
    {
        id: 116,
        fileCode: 'det',
        division: 'American League Central',
        name: 'Detroit Tigers',
    },
    {
        id: 117,
        fileCode: 'hou',
        division: 'American League West',
        name: 'Houston Astros',
    },
    {
        id: 118,
        fileCode: 'kc',
        division: 'American League Central',
        name: 'Kansas City Royals',
    },
    {
        id: 108,
        fileCode: 'ana',
        division: 'American League West',
        name: 'Los Angeles Angels',
    },
    {
        id: 119,
        fileCode: 'la',
        division: 'National League West',
        name: 'Los Angeles Dodgers',
    },
    {
        id: 146,
        fileCode: 'mia',
        division: 'National League East',
        name: 'Miami Marlins',
    },
    {
        id: 158,
        fileCode: 'mil',
        division: 'National League Central',
        name: 'Milwaukee Brewers',
    },
    {
        id: 142,
        fileCode: 'min',
        division: 'American League Central',
        name: 'Minnesota Twins',
    },
    {
        id: 121,
        fileCode: 'nym',
        division: 'National League East',
        name: 'New York Mets',
    },
    {
        id: 147,
        fileCode: 'nyy',
        division: 'American League East',
        name: 'New York Yankees',
    },
    {
        id: 133,
        fileCode: 'oak',
        division: 'American League West',
        name: 'Oakland Athletics',
    },
    {
        id: 143,
        fileCode: 'phi',
        division: 'National League East',
        name: 'Philadelphia Phillies',
    },
    {
        id: 134,
        fileCode: 'pit',
        division: 'National League Central',
        name: 'Pittsburgh Pirates',
    },
    {
        id: 135,
        fileCode: 'sd',
        division: 'National League West',
        name: 'San Diego Padres',
    },
    {
        id: 137,
        fileCode: 'sf',
        division: 'National League West',
        name: 'San Francisco Giants',
    },
    {
        id: 136,
        fileCode: 'sea',
        division: 'American League West',
        name: 'Seattle Mariners',
    },
    {
        id: 138,
        fileCode: 'stl',
        division: 'National League Central',
        name: 'St. Louis Cardinals',
    },
    {
        id: 139,
        fileCode: 'tb',
        division: 'American League East',
        name: 'Tampa Bay Rays',
    },
    {
        id: 140,
        fileCode: 'tex',
        division: 'American League West',
        name: 'Texas Rangers',
    },
    {
        id: 141,
        fileCode: 'tor',
        division: 'American League East',
        name: 'Toronto Blue Jays',
    },
    {
        id: 120,
        fileCode: 'was',
        division: 'National League East',
        name: 'Washington Nationals',
    },
]